import script from "./KnowledgeBaseAddEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseAddEdit.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseAddEdit.vue?vue&type=style&index=0&id=4e68e8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e68e8e4"]])

export default __exports__